// File: app.module.ts
// Author: Joseph M Diaz
// Date: 4/20/2017
// Desc: Root module for the app.
// Other Contributors: Brandon Shreve

import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app.routing';
import { SharedModule } from './shared/shared.module';
import { MescModule } from './components/mesc/mesc.module';
import { CtwrModule } from './components/ctwr/ctwr.module';

import { AppService } from './app.service';
import { AuthenticationService } from './auth.service';

import { AppComponent } from './app.component';
import { LoggedOutComponent } from './logged-out/logged-out.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';
import { UserProfileComponent } from './user-profile/user-profile.component';
import { BreadcrumbsComponent } from './shared/breadcrumbs/breadcrumbs.component';

@NgModule({
    imports: [
        AppRoutingModule,
        SharedModule,
        MescModule,
        CtwrModule,
    ],
    declarations: [
        AppComponent,
        LoggedOutComponent,
        NotFoundComponent,
        UnauthorizedComponent,
        BreadcrumbsComponent,
        UserProfileComponent,
    ],
    providers: [
        AppService,
        AuthenticationService,
    ],
    exports: [
        UserProfileComponent
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
